import React from 'react';
import SafeIcon from '../common/SafeIcon';
import BrandMark from './BrandMark';
import { FiSearch, FiMaximize, FiBell, FiChevronRight } from 'react-icons/fi';

const TopBar = ({ toggleCommandPalette, togglePresentationMode, isPresentationMode, activeView }) => {
  const getBreadcrumb = () => {
    switch(activeView) {
      case 'graph': return 'Link Graph';
      case 'demo': return 'Product Hub';
      default: return 'Q3 Growth Strategy';
    }
  };

  return (
    <div className="h-16 border-b border-paper-dark bg-paper-light/95 backdrop-blur-xl flex items-center justify-between px-6 z-20 shrink-0 select-none">
      <div className="flex items-center gap-4">
        <div className="flex items-center gap-3 text-xs font-bold uppercase tracking-widest text-ink-muted">
          <span className="hover:text-ink cursor-pointer transition-colors max-md:hidden">Ecosystem</span>
          <SafeIcon icon={FiChevronRight} className="w-3 h-3 max-md:hidden" />
          <span className="text-ink font-black text-[11px] bg-paper px-3 py-1 rounded-full border border-paper-dark">{getBreadcrumb()}</span>
        </div>
      </div>

      <div className="flex items-center gap-2 md:gap-4">
        <button 
          onClick={toggleCommandPalette}
          className="flex items-center gap-3 px-4 py-2 bg-paper border border-paper-dark hover:border-maple/30 rounded-xl text-[10px] font-black text-ink-muted transition-all shadow-sm group"
        >
          <SafeIcon icon={FiSearch} className="group-hover:text-maple transition-colors" />
          <span className="max-md:hidden tracking-[0.1em]">SEARCH SYSTEMS (CMD + K)</span>
        </button>
        
        <div className="w-px h-6 bg-paper-dark mx-1"></div>

        <div className="flex items-center gap-1">
          <button 
            onClick={togglePresentationMode}
            className={`p-2.5 rounded-xl transition-all ${isPresentationMode ? 'bg-maple text-white shadow-lg shadow-maple/20' : 'text-ink-muted hover:bg-paper hover:text-ink border border-transparent hover:border-paper-dark'}`}
            title="Focus Mode"
          >
            <SafeIcon icon={FiMaximize} className="w-4 h-4" />
          </button>

          <button className="p-2.5 text-ink-muted hover:bg-paper hover:text-ink rounded-xl transition-all border border-transparent hover:border-paper-dark max-md:hidden">
            <SafeIcon icon={FiBell} className="w-4 h-4" />
          </button>
        </div>

        <div className="relative group cursor-pointer">
          <div className="w-9 h-9 rounded-xl bg-ink text-white flex items-center justify-center shadow-lg shadow-ink/10 border-2 border-white overflow-hidden">
            <span className="text-xs font-black">JD</span>
          </div>
          <div className="absolute top-0 right-0 w-3 h-3 bg-green-500 border-2 border-white rounded-full"></div>
        </div>
      </div>
    </div>
  );
};

export default TopBar;